// Compare history: last 3 unique sets, each is a sorted list of coach_ids.
const KEY = "earnit_compare_history";
const MAX = 3;

const sig = (ids) => [...ids].sort().join("|");

export const getHistory = () => {
    try {
        return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
        return [];
    }
};

export const pushHistory = (ids) => {
    if (!ids || ids.length < 2) return;
    const s = sig(ids);
    const now = Date.now();
    const list = getHistory().filter((h) => sig(h.ids) !== s);
    list.unshift({ id: s, ids: [...ids], at: now });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
};
